export const tieredmenu = {
  colorScheme: {
    light: {
      background: '#ffffff',
      border: {
        color: '#e3eaef',
        radius: '6px',
      },
      color: '#0e2a4a',
      shadow:
        '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      transition: {
        duration: '0.2s',
      },
      list: {
        padding: '0.5rem 0',
        gap: '0.25rem',
      },
      item: {
        focus: {
          background: '#eef4f7',
          color: '#0e2a4a',
        },
        active: {
          background: '#e3eaef',
          color: '#0e2a4a',
        },
        color: '#0e2a4a',
        padding: '0.5rem 1rem',
        border: {
          radius: '4px',
        },
        gap: '0.5rem',
        icon: {
          color: '#5b6b7c',
          focus: {
            color: '#0e2a4a',
          },
          active: {
            color: '#0e2a4a',
          },
        },
      },
      submenu: {
        mobile: {
          indent: '0.5rem',
        },
        label: {
          padding: '0.5rem 1rem',
          font: {
            weight: '600',
          },
          background: '#ffffff',
          color: '#0e2a4a',
        },
        icon: {
          size: '0.75rem',
          color: '#5b6b7c',
          focus: {
            color: '#0e2a4a',
          },
          active: {
            color: '#0e2a4a',
          },
        },
      },
      separator: {
        border: {
          color: '#e3eaef',
        },
      },
    },
    dark: {
      background: '#1f2937',
      border: {
        color: '#374151',
        radius: '6px',
      },
      color: '#ffffff',
      shadow:
        '0 4px 6px -1px rgba(0, 0, 0, 0.25), 0 2px 4px -1px rgba(0, 0, 0, 0.2)',
      transition: {
        duration: '0.2s',
      },
      list: {
        padding: '0.5rem 0',
        gap: '0.25rem',
      },
      item: {
        focus: {
          background: '#374151',
          color: '#ffffff',
        },
        active: {
          background: '#4b5563',
          color: '#ffffff',
        },
        color: '#ffffff',
        padding: '0.5rem 1rem',
        border: {
          radius: '4px',
        },
        gap: '0.5rem',
        icon: {
          color: '#9ca3af',
          focus: {
            color: '#ffffff',
          },
          active: {
            color: '#ffffff',
          },
        },
      },
      submenu: {
        mobile: {
          indent: '0.5rem',
        },
        label: {
          padding: '0.5rem 1rem',
          font: {
            weight: '600',
          },
          background: '#1f2937',
          color: '#ffffff',
        },
        icon: {
          size: '0.75rem',
          color: '#9ca3af',
          focus: {
            color: '#ffffff',
          },
          active: {
            color: '#ffffff',
          },
        },
      },
      separator: {
        border: {
          color: '#374151',
        },
      },
    },
  },
};
